// extracted by mini-css-extract-plugin
export var positionBottom = "tool-tip-module--positionBottom--ITMoD";
export var positionTop = "tool-tip-module--positionTop--osNMb";
export var root = "tool-tip-module--root--LAKFq";